// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1QD4B","top":"styles_top__1zHwu"};